import "./archiveCustomerStories.scss";
import "../../src-utilities/header";
import "../../src-utilities/footer";

import gsap, { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

// Category toggle (open/close) 
document
  .querySelector(".category-text")
  .addEventListener("click", function (e) {
    if (e.currentTarget.parentNode.classList.contains("open")) {
      e.currentTarget.parentNode.classList.remove("open");
      document.querySelector(".expend-div").classList.remove("open");
    } else {
      e.currentTarget.parentNode.classList.add("open");
      document.querySelector(".expend-div").classList.add("open");
    }
  });

// Filter tag toggle (checked/unchecked)
Array.from(document.querySelectorAll(".filter-type")).forEach((filterType) => {
  console.log(filterType);
  filterType.addEventListener("click", (event) => {
    event.target.classList.toggle("checked");
  });
});

// Months array 
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// State─
let currentPage = 1;
let totalPage = 1;
let ids = "";
let search = "";
let sortOrder = "desc";

const showMoreBtn = document.querySelector("#post_btn");

// FIX: target .resource-list
const resourceList = document.querySelector(".resource-list");

// URL builders 
function generateURL() {
  const tagParam = ids ? `&tags=${ids}` : "";
  const searchParam = search ? `&search=${search}` : "";
  return `/wp-json/wp/v2/customer-stories?_fields=acf,title,link,excerpt,date&per_page=90&page=${currentPage}&order=${sortOrder}${tagParam}${searchParam}`;
}

function generateURLForBtn() {
  const tagParam = ids ? `&tags=${ids}` : "";
  const searchParam = search ? `&search=${search}` : "";
  return `/wp-json/wp/v2/customer-stories?_fields=acf,title,link,excerpt,date&per_page=10&page=${currentPage}&order=${sortOrder}${tagParam}${searchParam}`;
}

// Loader
// FIX: renders into .resource-list (not .blogs-data which doesn't exist in your HTML)
function renderLoader() {
  resourceList.innerHTML = `
    <div id="blog-loader" style="display:flex; justify-content:center; padding:60px 0;">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <defs>
          <linearGradient id="myGradient2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#FF80AD" />
            <stop offset="100%" stop-color="#FFD164" />
          </linearGradient>
        </defs>
        <g transform="translate(0 -7.5)">
          <circle cx="50" cy="41" r="10" fill="#f5f5f5">
            <animateTransform attributeName="transform" type="rotate" dur="1s"
              repeatCount="indefinite" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
            <animate attributeName="r" dur="1s" repeatCount="indefinite" calcMode="spline"
              keyTimes="0;0.5;1" values="0;15;0" keySplines="0.2 0 0.8 1;0.2 0 0.8 1"></animate>
          </circle>
          <circle cx="50" cy="41" r="10" fill="url(#myGradient2)">
            <animateTransform attributeName="transform" type="rotate" dur="1s"
              repeatCount="indefinite" keyTimes="0;1" values="180 50 50;540 50 50"></animateTransform>
            <animate attributeName="r" dur="1s" repeatCount="indefinite" calcMode="spline"
              keyTimes="0;0.5;1" values="15;0;15" keySplines="0.2 0 0.8 1;0.2 0 0.8 1"></animate>
          </circle>
        </g>
      </svg>
    </div>`;
}

// HTML card builder
// FIX: card structure exactly matches your PHP HTML template:
//   .resource-data > a > .blog-feature-image + .blog-content > .blog-timeline + .blog-title
function getHTML(data) {
  console.log(data);
  console.log("-----------------------------------------------");
  console.log(data.acf);
  const date = new Date(data.date);
  const dateStr = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  const imageURL = data.acf?.listing_image || data.acf?.featured_image || "";
  const altText = data.acf?.banner_alt_text || "blog-image";
  const title = data.title?.rendered || "";
  const link = data.link || "#";

  return `<div class="resource-data">
    <a href="${link}">
      <div class="blog-feature-image">
        <img width="832" height="419" loading="lazy"
          src="${imageURL}"
          alt="${altText}"
          class="resource-img">
      </div>
      <div class="blog-content">
        <div class="blog-timeline">
          <p>
            <span class="svg-image">
              <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd" stroke="#200E32" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1.5" transform="translate(3 2)">
                  <line x1=".093" x2="17.917" y1="7.404" y2="7.404"></line>
                  <line x1="13.442" x2="13.451" y1="11.31" y2="11.31"></line>
                  <line x1="9.005" x2="9.014" y1="11.31" y2="11.31"></line>
                  <line x1="4.558" x2="4.567" y1="11.31" y2="11.31"></line>
                  <line x1="13.442" x2="13.451" y1="15.196" y2="15.196"></line>
                  <line x1="9.005" x2="9.014" y1="15.196" y2="15.196"></line>
                  <line x1="4.558" x2="4.567" y1="15.196" y2="15.196"></line>
                  <line x1="13.044" x2="13.044" y2="3.291"></line>
                  <line x1="4.966" x2="4.966" y2="3.291"></line>
                  <path d="M13.2382655,1.57919622 L4.77096342,1.57919622
                    C1.83427331,1.57919622 0,3.21513002 0,6.22222222 L0,15.2718676
                    C0,18.3262411 1.83427331,20 4.77096342,20 L13.2290015,20
                    C16.1749556,20 18,18.3546099 18,15.3475177 L18,6.22222222
                    C18.0092289,3.21513002 16.1842196,1.57919622 13.2382655,1.57919622 Z">
                  </path>
                </g>
              </svg>
            </span>
            <span class="date-time">${dateStr}</span>
          </p>
        </div>
        <div class="blog-title">
          <h2 class="blog-heading">${title}</h2>
        </div>
      </div>
    </a>
  </div>`;
}

// Render posts (replaces resource-list content)
function renderPost(blogs) {
  console.log("CUSTOMER STORIES LIST - ", blogs);
  resourceList.innerHTML = blogs.map(getHTML).join("");
}

// Append posts (for Show More) 
function appendPosts(blogs) {
  resourceList.insertAdjacentHTML("beforeend", blogs.map(getHTML).join(""));
}

// Show / hide "Show More" button
function moreBtn(isShown) {
  if (showMoreBtn) showMoreBtn.style.display = isShown ? "block" : "none";
}

// Not Found
function notFound() {
  resourceList.innerHTML = `
    <div class="not-found">
      <img src="https://cdni.iconscout.com/illustration/premium/thumb/webpage-not-found-4606305-3809638.png"
        alt="Not Found">
      <div class="button-div">
        <button id="reset" class="reset-button">Reset Filter</button>
      </div>
    </div>`;
  document.querySelector("#reset").addEventListener("click", resetFilter);
}

// Core fetch + render
async function fetchAndRender() {
  renderLoader();
  try {
    const response = await fetch(generateURL());
    totalPage = Number(response.headers.get("X-WP-TotalPages")) || 1;
    let data = await response.json();

    if (!Array.isArray(data) || !data.length) {
      notFound();
      moreBtn(false);
      return;
    }

    // Client-side multi-word title filter for accurate search
    if (search) {
      const words = search.split(/\s+/);
      data = data.filter((blog) => {
        const title = blog.title.rendered.toLowerCase();
        return words.every((w) => title.includes(w));
      });
    }

    if (!data.length) {
      notFound();
      moreBtn(false);
      return;
    }

    moreBtn(totalPage > currentPage);
    renderPost(data);
  } catch (err) {
    console.error("fetchAndRender error:", err);
    notFound();
  }
}

// Reset all filters
async function resetFilter() {
  document
    .querySelectorAll(".checked")
    .forEach((el) => el.classList.remove("checked"));
  const searchInput = document.querySelector("#search");
  if (searchInput) searchInput.value = "";

  ids = "";
  search = "";
  currentPage = 1;

  await fetchAndRender();
}

document.querySelector(".result").addEventListener("click", async () => {
  document.querySelector(".category-text").click();
  const activeFilters = Array.from(document.querySelectorAll(".checked"));
  ids = activeFilters.map((f) => f.dataset.id).join(",");
  currentPage = 1;
  await fetchAndRender();
});

// "Clear All" button
document.querySelector(".clear-all").addEventListener("click", resetFilter);

// Search input (debounced, respects active category filter)
let searchTimeout;
document.querySelector("#search").addEventListener("input", (event) => {
  clearTimeout(searchTimeout);
  searchTimeout = setTimeout(async () => {
    search = event.target.value.trim().toLowerCase();
    currentPage = 1;
    await fetchAndRender();
  }, 300);
});

// Sort By (works with category + search)
const sortBtn = document.querySelector(".filter-sortby");
const sortOptions = document.querySelectorAll(".sorting p");

sortBtn.addEventListener("click", () => {
  sortBtn.classList.toggle("active");
});

sortOptions.forEach((option) => {
  option.addEventListener("click", async (event) => {
    event.stopPropagation();
    sortOrder = option.dataset.find; // "asc" or "desc"
    currentPage = 1;
    document.querySelector("#sort-by").textContent = event.target.textContent;
    sortBtn.classList.remove("active");
    await fetchAndRender();
  });
});

// "Show More" button─
showMoreBtn.addEventListener("click", async () => {
  if (currentPage >= totalPage) return;
  currentPage++;

  try {
    const response = await fetch(generateURLForBtn());
    let data = await response.json();

    if (!Array.isArray(data) || !data.length) {
      moreBtn(false);
      return;
    }

    // Client-side multi-word title filter
    if (search) {
      const words = search.split(/\s+/);
      data = data.filter((blog) => {
        const title = blog.title.rendered.toLowerCase();
        return words.every((w) => title.includes(w));
      });
    }

    if (currentPage >= totalPage) moreBtn(false);

    // FIX: uses appendPosts so existing cards stay visible
    appendPosts(data);
  } catch (err) {
    console.error("Show More error:", err);
  }
});
